import { render, staticRenderFns } from "./promotion-coupon.vue?vue&type=template&id=23c15db8&"
import script from "./promotion-coupon.vue?vue&type=script&lang=js&"
export * from "./promotion-coupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports